(function ($, Modernizr) {

    var polyfillUrl = "/js/polyfills/";

    $(function () {
        loadPolyfills();
    });

    function loadPolyfills() {

        var polyfills = [{
                test: !Modernizr.flexbox,
                script: [polyfillUrl + 'flexie.min.js']
            },
            {
                test: !Modernizr.objectfit,
                script: [polyfillUrl + 'object-fit-images.min.js'],
                done: function() {
                    objectFitImages();
                }
            }
        ];

        for (var i = 0; i < polyfills.length; i++) {
            if (polyfills[i].test) {
                loadScript(polyfills[i].script, polyfills[i].done);
            }
        }
    }

    function loadScript(src, done) {
        if( typeof done !== "function") {
            done = function() {};
        }
        var js = document.createElement('script');
        js.src = src;
        js.onload = function () {
            done();
        };
        js.onerror = function () {
            done(new Error('Failed to load script ' + src));
        };
        document.body.appendChild(js);
    }

}($, Modernizr));